import {
	Grid,
	Typography,
	Snackbar,
	Alert,
	Button
} from '@mui/material';
import React, { useState } from 'react';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { EditarUsuario } from './EditarUsuario';
import { delUsuario } from '../../../services/apis';

export const UsuarioCard = ({
	usuario,
	opciones,
	cargarUsuarios,
	departamentos,
	roles
}) => {

	const [openEdit, setOpenEdit] = useState(false);

	// =========================
	// SNACKBAR STATES
	// =========================
	const [openConfirm, setOpenConfirm] = useState(false);
	const [openSuccess, setOpenSuccess] = useState(false);
	const [openError, setOpenError] = useState(false);
	const [loadingDelete, setLoadingDelete] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');

	const handleEvent = (opcionId) => {
		if (opcionId === 1) setOpenEdit(true);
		if (opcionId === 2) setOpenConfirm(true);
	};

	const confirmarEliminacion = async () => {
		setLoadingDelete(true);
		try {
			const response = await delUsuario(usuario.id);
			if (response?.success) {
				setOpenConfirm(false);
				setOpenSuccess(true);
				cargarUsuarios();
			} else {
				setErrorMsg(response?.error || 'Error al eliminar el usuario');
				setOpenError(true);
			}
		} catch {
			setErrorMsg('Error de conexión con el servidor');
			setOpenError(true);
		} finally {
			setLoadingDelete(false);
		}
	};

	return (
		<>
			{/* =========================
				FILA / TARJETA RESPONSIVE
			========================= */}
			<Grid
				container
				size={{ xs: 12 }}
				sx={{
					px: 2,
					py: 1.5,
					borderBottom: '1px solid',
					borderColor: 'divider',
					background: 'var(--fondoTarjeta)',
					'&:hover': { backgroundColor: 'action.hover' }
				}}
			>

				{/* =========================
					MOBILE (xs)
				========================= */}
				<Grid
					container
					size={{ xs: 12 }}
					alignItems="center"
					sx={{ display: { xs: 'flex', sm: 'none' } }}
				>
					<Grid item size={{ xs: 2 }}>
						<AccountCircleIcon sx={{ fontSize: 36, color: usuario.color }} />
					</Grid>

					<Grid item size={{ xs: 8 }}>
						<Typography variant="body1" fontWeight={600} noWrap>
							{usuario.nombre}
						</Typography>
						<Typography variant="caption" color="text.secondary">
							{usuario.nombre_rol}
							{usuario.nombre_departamento && ` · ${usuario.nombre_departamento}`}
						</Typography>
					</Grid>

					<Grid item size={{ xs: 2 }} sx={{ textAlign: 'right' }}>
						<OpcionesMenuFunc
							small
							variant="text"
							opciones={opciones}
							handleEvent={handleEvent}
						/>
					</Grid>
				</Grid>

				{/* =========================
					DESKTOP (sm+)
				========================= */}
				<Grid
					container
					size={{ xs: 12 }}
					alignItems="center"
					sx={{ display: { xs: 'none', sm: 'flex' } }}
				>
					<Grid item size={{ sm: 1 }}>
						<AccountCircleIcon sx={{ fontSize: 32, color: usuario.color }} />
					</Grid>

					<Grid item size={{ sm: 4 }}>
						<Typography variant="body2" fontWeight={500} noWrap>
							{usuario.nombre}
						</Typography>
					</Grid>

					<Grid item size={{ sm: 3 }}>
						<Typography variant="body2">
							{usuario.nombre_rol}
						</Typography>
					</Grid>

					<Grid item size={{ sm: 3 }}>
						<Typography variant="body2">
							{usuario.nombre_departamento || '—'}
						</Typography>
					</Grid>

					<Grid item size={{ sm: 1 }} sx={{ textAlign: 'right' }}>
						<OpcionesMenuFunc
							small
							variant="text"
							opciones={opciones}
							handleEvent={handleEvent}
						/>
					</Grid>
				</Grid>

				{/* MODAL EDITAR */}
				{openEdit && (
					<EditarUsuario
						open={openEdit}
						setOpen={setOpenEdit}
						cargarUsuarios={cargarUsuarios}
						departamentos={departamentos}
						roles={roles}
						usuarioData={usuario}
					/>
				)}
			</Grid>

			{/* =========================
				SNACKBARS
			========================= */}
			<Snackbar open={openConfirm} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
				<Alert
					severity="warning"
					action={
						<>
							<Button size="small" onClick={() => setOpenConfirm(false)}>Cancelar</Button>
							<Button size="small" color="error" onClick={confirmarEliminacion}>Eliminar</Button>
						</>
					}
				>
					¿Eliminar a <strong>{usuario.nombre}</strong>?
				</Alert>
			</Snackbar>

			<Snackbar open={openSuccess} autoHideDuration={3000} onClose={() => setOpenSuccess(false)}>
				<Alert severity="success">Usuario eliminado correctamente</Alert>
			</Snackbar>

			<Snackbar open={openError} autoHideDuration={4000} onClose={() => setOpenError(false)}>
				<Alert severity="error">{errorMsg}</Alert>
			</Snackbar>
		</>
	);
};
